import {useState, useEffect} from 'react'
import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import {KTCard} from '../../../../../_metronic/helpers'
import {compareAsc} from 'date-fns'
import {getReport} from './core/_requests'

const reportBreadcrumbs: Array<PageLink> = [
  {
    title: 'Relatório',
    path: '/apps/reports/list',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ReportPage = () => {
  const [reportType, setReportType] = useState<string>('')
  const [reportInitialDate, setReportInitialDate] = useState<string>('')
  const [reportFinalDate, setReportFinalDate] = useState<string>('')
  const [columnName, setColumnName] = useState<string>('')

  function isStartDateBeforeEndDate(startDateStr, endDateStr): Boolean {
    const startDate = new Date(startDateStr)
    const endDate = new Date(endDateStr)

    return compareAsc(startDate, endDate) < 0
  }

  function downloadBase64File(base64Data, fileName) {
    // Decodifica o base64 em uma string representando os bytes do arquivo
    const byteCharacters = atob(base64Data)

    // Converte essa string em um array de bytes
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }

    // Converte o array de bytes em um Blob
    const byteArray = new Uint8Array(byteNumbers)
    const fileBlob = new Blob([byteArray], {type: 'application/octet-stream'}) // Use o MIME type correto

    // Cria um URL para o blob
    const blobUrl = URL.createObjectURL(fileBlob)

    // Cria um link temporário para download
    const link = document.createElement('a')
    link.href = blobUrl
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()

    // Limpeza
    document.body.removeChild(link)
    URL.revokeObjectURL(blobUrl)
  }

  const handleSolicitation = async () => {
    if (!reportType || !reportInitialDate || !reportFinalDate) {
      alert('Preencha todos os campos')
    }

    // if (isStartDateBeforeEndDate(reportInitialDate, reportFinalDate)) {
    //   alert('A data inicial não pode ser maior que a data final')
    // }

    const base64File = await getReport(reportInitialDate, reportFinalDate, columnName, reportType)

    downloadBase64File(base64File, 'report.xlsx')
  }

  useEffect(() => {
    setColumnName('dataCriacao')
  }, [reportType])

  const dataTypes = [
    {
      name: 'protocol',
      types: [
        {name: 'Data da criação', value: 'dataCriacao', default: true},
        {name: 'Data da alteração', value: 'dataAlteracao', default: false},
        {name: 'Data do recebimento', value: 'dataRecebimento', default: false},
      ],
    },
    {
      name: 'proposal',
      types: [
        {name: 'Data da criação', value: 'dataCriacao', default: true},
        {name: 'Data da alteração', value: 'dataAlteracao', default: false},
        {name: 'Data do recebimento', value: 'dataRecebimento', default: false},
        {name: 'Data da venda', value: 'dataVenda', default: false},
        {name: 'Data da incorporação', value: 'dataIncorporacao', default: false},
        {name: 'Data da liberação', value: 'dataLiberacao', default: false},
        {name: 'Data do SCR', value: 'dataSCR', default: false},
      ],
    },
    {
      name: 'proposal/solicitations',
      types: [
        {name: 'Data da criação', value: 'dataCriacao', default: true},
        {name: 'Data da alteração', value: 'dataAlteracao', default: false},
        {name: 'Data da conferência', value: 'dataConferencia', default: false},
      ],
    },
  ]

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list'
          element={
            <>
              <KTCard></KTCard>
              <KTCard>
                <PageTitle breadcrumbs={reportBreadcrumbs}>Relatórios</PageTitle>

                <div className='card mb-5 mb-xl-10'>
                  <div
                    className='card-header border-0 cursor-pointer'
                    role='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#kt_account_profile_details'
                    aria-expanded='true'
                    aria-controls='kt_account_profile_details'
                  >
                    <div className='card-title m-0'>
                      <h3 className='fw-bold m-0'>Relatórios</h3>
                    </div>
                  </div>

                  <div id='kt_account_settings_profile_details' className='collapse show'>
                    <form
                      id='kt_account_profile_details_form'
                      className='form fv-plugins-bootstrap5 fv-plugins-framework'
                    >
                      <div className='card-body border-top p-9'>
                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                            Tipo de relatório
                          </label>

                          <div className='col-lg-8'>
                            <div className='row'>
                              <div className='col-lg-6 fv-row fv-plugins-icon-container'></div>

                              <div className='col-lg-6 fv-row fv-plugins-icon-container'>
                                <select
                                  className='form-select form-select-solid w-250px ps-14'
                                  onChange={(e) => setReportType(e.target.value)}
                                >
                                  <option value=''>Selecione</option>
                                  <option value='proposal'>Propostas</option>
                                  <option value='protocol'>Protocolos</option>
                                  <option value='proposal/solicitations'>
                                    Solicitação de documentos
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                            Data a pesquisar
                          </label>

                          <div className='col-lg-8'>
                            <div className='row'>
                              <div className='col-lg-6 fv-row fv-plugins-icon-container'></div>

                              <div className='col-lg-6 fv-row fv-plugins-icon-container'>
                                <select
                                  className='form-select form-select-solid w-250px ps-14'
                                  onChange={(e) => setColumnName(e.target.value)}
                                >
                                  {dataTypes
                                    .find((type) => type.name === reportType)
                                    ?.types.map((field) => (
                                      <option value={field.value} selected={field.default}>
                                        {field.name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                            Data inicial
                          </label>

                          <div className='col-lg-8'>
                            <div className='row'>
                              <div className='col-lg-6 fv-row fv-plugins-icon-container'></div>

                              <div className='col-lg-6 fv-row fv-plugins-icon-container'>
                                <input
                                  type='date'
                                  className='form-control form-control-solid w-250px ps-14'
                                  onChange={(e) => setReportInitialDate(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='row mb-6'>
                          <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                            Data final
                          </label>

                          <div className='col-lg-8'>
                            <div className='row'>
                              <div className='col-lg-6 fv-row fv-plugins-icon-container'></div>

                              <div className='col-lg-6 fv-row fv-plugins-icon-container'>
                                <input
                                  type='date'
                                  className='form-control form-control-solid w-250px ps-14'
                                  onChange={(e) => setReportFinalDate(e.target.value)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className='card-footer d-flex justify-content-end py-6 px-9'>
                        <button
                          type='button'
                          className='btn btn-primary'
                          id='kt_account_profile_details_submit'
                          onClick={handleSolicitation}
                        >
                          Enviar
                        </button>
                      </div>

                      <input type='hidden' />
                    </form>
                  </div>
                </div>
              </KTCard>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/reports/list' />} />
    </Routes>
  )
}

export default ReportPage
